Object.defineProperty(exports, "__esModule", { value: true });
var CMS = {
    CAR_LANDING: '/car-insurance/',
    CAR_RESULTS: '/motor/car-insurance/results/',
    TAXI_LANDING: '/commercial-car-insurance/',
    CAR_DELAER: '/motor/dealer/',
    BIKE_LANDING: '/two-wheeler-insurance/',
    BIKE_FALLBACK: '/two-wheeler-insurance/product/',
    BIKE_RESULTS: '/two-wheeler-insurance/results/',
    BIKE_PROPOSAL: '/two-wheeler-insurance/buyplan/',
    TRAVEL_SINGLETRIP: '/travel-insurance/',
    TRAVEL_MULTITRIP: '/travel-insurance/multi-trip/',
    HEALTH_INDEMNITY: '/health-insurance/',
    HEALTH_SUPERTOPUP: '/health-insurance/super-topup/',
    LIFE_LANDING: '/term-insurance/',
    LIFE_RESULTS: '/term-insurance/quotes/',
    LIFE_PLANQUOTE: '/term-insurance/quotes/plan/',
    LIFE_PROPOSAL: '/term-insurance/buyplan/',
    ULIP_LANDING: '/ulip-insurance/',
    ULIP_RESULTS: '/ulip-insurance/quotes/',
    CAR_CMS: '/car-insurance-product/',
    TAXI_CMS: '/commercial-car-insurance/',
    BIKE_CMS: '/two-wheeler-insurance-product/',
    HEALTH_CMS: '/health-insurance-product/',
    TRAVEL_CMS: '/travel-insurance-product/',
    LIFE_CMS: '/term-insurance-product/',
    ULIP_CMS: '/ulip-insurance/',
    USER_ACCOUNT: window['MY_ACC_LINK'] || '/user/manage-policies/',
    USER_FORM_SAVE: '/user-form/save/',
    GET_COVER: '/lp/car-insurance/get-cover/',
};
if (window['IS_MOBILE_DEVICE']) {
    CMS.BIKE_LANDING = '/motor/twowheeler-insurance/';
    CMS.CAR_LANDING = '/motor/car-insurance/';
}
exports.default = CMS;
